import { ENV_LIT_NETWORK, getUrls } from '@shared/utils/config/environment';
import { ethers } from 'ethers';
import { executeDirectTransactionsEVM } from '@shared/utils/evm/executeDirectTransactionsEVM';
import { deepConvertBigInt } from '@shared/utils/off-chain/deep-convert-bigint';
import { PUBLIC_RPCS } from '@shared/utils/config/networks';
import { simulateEVMTransactionsClient } from '@/lib/trade/simulateEVMTransactionsClient';
import { createDBOrderHistory } from '@/lib/db/DBOrderHistoryHelpers';
import { createTDBOrder } from '@/lib/db/DBOrderHelpers';
import { createDBTransferReceipt } from '@/lib/db/DBTransferHistoryHelpers';
export default async function executeViaClientEVM({
  params,
  pkp,
  orderType,
  dbOrderParams,
  signer,
  existingdbOrder,
  additionalDecodedResponse,
  additionalExecutionTime,
  skipSimulation,
  transferParams
}) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j;
  const isSingleChain = !(params === null || params === void 0 ? void 0 : params.bridge);
  try {
    const tokenPrices = dbOrderParams === null || dbOrderParams === void 0 ? void 0 : dbOrderParams.tokenPrices;
    const toAssetPriceData = dbOrderParams === null || dbOrderParams === void 0 ? void 0 : dbOrderParams.toAssetPriceData;
    const dbOrderType = dbOrderParams === null || dbOrderParams === void 0 ? void 0 : dbOrderParams.dbOrderType;
    const transactions = params === null || params === void 0 ? void 0 : params.transactions;
    const result = {
      message: `${orderType} client execution called`
    };
    const approvalTransactions = transactions === null || transactions === void 0 ? void 0 : transactions.allowance;
    const swapTransactions = ((transactions === null || transactions === void 0 ? void 0 : transactions.transfer) ? [transactions === null || transactions === void 0 ? void 0 : transactions.transfer] : [transactions === null || transactions === void 0 ? void 0 : transactions.swap]).filter(x => x);
    const dbOrder = existingdbOrder ? existingdbOrder : (await createTDBOrder({
      cloud_wallet_address: pkp === null || pkp === void 0 ? void 0 : pkp.additionalEthAddress,
      order: params,
      pkp,
      token_prices: tokenPrices,
      order_type: dbOrderType,
      pkp_eth_address: pkp === null || pkp === void 0 ? void 0 : pkp.ethAddress
    })).data;
    console.log('Executing order EVM dbOrder=>', dbOrder);
    const provider = new ethers.providers.JsonRpcProvider(PUBLIC_RPCS[(_a = swapTransactions === null || swapTransactions === void 0 ? void 0 : swapTransactions[0]) === null || _a === void 0 ? void 0 : _a.chainId]);
    const gasPrice = (_b = await provider.getGasPrice()) === null || _b === void 0 ? void 0 : _b.toString();
    const startTime = new Date().getTime();
    let executionResponse;
    let simulateResult;
    console.log(`Executing order EVM ${orderType} client side`, approvalTransactions, swapTransactions);
    if (!skipSimulation) {
      simulateResult = await simulateEVMTransactionsClient({
        network: swapTransactions === null || swapTransactions === void 0 ? void 0 : swapTransactions[0].chainId,
        transactions: [...approvalTransactions, ...swapTransactions]
      });
      console.log(`Executing order EVM ${orderType} client side simuations`, simulateResult, swapTransactions);
      if (!(simulateResult === null || simulateResult === void 0 ? void 0 : simulateResult.simsPassed) || (simulateResult === null || simulateResult === void 0 ? void 0 : simulateResult.status) == 'error') {
        throw new Error(`Simulation Error: ${simulateResult === null || simulateResult === void 0 ? void 0 : simulateResult.error}`);
      }
    }
    delete swapTransactions[0].from;
    approvalTransactions.forEach(x => {
      delete x.from;
    });
    swapTransactions[0].value = BigInt(swapTransactions[0].value);
    let executionResponseError = null;
    try {
      executionResponse = await executeDirectTransactionsEVM({
        transactions: [...approvalTransactions, ...swapTransactions],
        network: (_c = swapTransactions === null || swapTransactions === void 0 ? void 0 : swapTransactions[0]) === null || _c === void 0 ? void 0 : _c.chainId,
        wallet: signer,
        blockConfirmations: 0,
        legacyPayloads: [...(approvalTransactions ? approvalTransactions.map(x => {
          return {
            gasPrice: x.gasPrice ? x.gasPrice : gasPrice,
            gasLimit: x.gasLimit
          };
        }) : []), (swapTransactions === null || swapTransactions === void 0 ? void 0 : swapTransactions[0]) ? {
          gasPrice: swapTransactions[0].gasPrice ? swapTransactions[0].gasPrice : gasPrice,
          gasLimit: swapTransactions[0].gasLimit
        } : undefined].filter(Boolean)
      });
      if (!((_d = executionResponse === null || executionResponse === void 0 ? void 0 : executionResponse[0]) === null || _d === void 0 ? void 0 : _d.transactionHash)) {
        throw new Error(`Error executing transaction`);
      }
    } catch (e) {
      executionResponseError = e.message;
    }
    const approvalHash = (approvalTransactions === null || approvalTransactions === void 0 ? void 0 : approvalTransactions.length) ? (_e = executionResponse === null || executionResponse === void 0 ? void 0 : executionResponse[0]) === null || _e === void 0 ? void 0 : _e.transactionHash : null;
    const executionHash = ((_f = executionResponse === null || executionResponse === void 0 ? void 0 : executionResponse[1]) === null || _f === void 0 ? void 0 : _f.transactionHash) || ((_g = executionResponse === null || executionResponse === void 0 ? void 0 : executionResponse[0]) === null || _g === void 0 ? void 0 : _g.transactionHash);
    console.log('Executing order EVM hashes', approvalHash, executionHash, executionResponse);
    if (orderType === null || orderType === void 0 ? void 0 : orderType.includes('WITHDRAW')) {
      // Wait for txn to be mined one block
      const txnReceipt = await provider.waitForTransaction(executionHash, 1);
      const error = parseInt((_h = txnReceipt === null || txnReceipt === void 0 ? void 0 : txnReceipt.status) === null || _h === void 0 ? void 0 : _h.toString()) === 0;
      if (error) {
        throw new Error('Transaction failed to land on chain');
      }
    }
    const decodedResponse = {
      type: orderType,
      status: executionResponseError ? 'error' : 'success',
      error: executionResponseError,
      note: 'Client side execution',
      quoteId: params.quoteId,
      quote: params,
      approvalTransactions: approvalTransactions.map(x => {
        return {
          unsignedTx: x,
          network: x.chainId,
          hash: approvalHash,
          status: 'success'
        };
      }),
      swapTransaction: isSingleChain ? {
        unsignedTx: swapTransactions[0],
        network: swapTransactions[0].chainId,
        hash: executionHash,
        status: 'success'
      } : null,
      swapTransactions: !isSingleChain && !(orderType === null || orderType === void 0 ? void 0 : orderType.includes('WITHDRAW')) ? [{
        unsignedTx: swapTransactions === null || swapTransactions === void 0 ? void 0 : swapTransactions[0],
        network: swapTransactions === null || swapTransactions === void 0 ? void 0 : swapTransactions[0].chainId,
        hash: executionHash
      }] : null,
      transferTransaction: (orderType === null || orderType === void 0 ? void 0 : orderType.includes('WITHDRAW')) ? {
        unsignedTx: swapTransactions === null || swapTransactions === void 0 ? void 0 : swapTransactions[0],
        network: swapTransactions === null || swapTransactions === void 0 ? void 0 : swapTransactions[0].chainId,
        hash: executionHash,
        status: 'success'
      } : null,
      simulateResult
    };
    console.log('Executing order EVM SWAP_SINGLE output client side', orderType, executionResponse, executionHash);
    console.log(`Executing order EVM ${orderType} client side`, executionResponse, executionHash, decodedResponse);
    let executionTime = new Date().getTime() - startTime;
    if (additionalExecutionTime) {
      executionTime += additionalExecutionTime;
    }
    if (additionalDecodedResponse) {
      decodedResponse['sponsorTransactions'] = (additionalDecodedResponse === null || additionalDecodedResponse === void 0 ? void 0 : additionalDecodedResponse.sponsorTransactions) || (additionalDecodedResponse === null || additionalDecodedResponse === void 0 ? void 0 : additionalDecodedResponse.sponsorTransaction);
      decodedResponse['sponsorTransaction'] = (additionalDecodedResponse === null || additionalDecodedResponse === void 0 ? void 0 : additionalDecodedResponse.sponsorTransactions) || (additionalDecodedResponse === null || additionalDecodedResponse === void 0 ? void 0 : additionalDecodedResponse.sponsorTransaction);
    }
    result['decodedResponse'] = decodedResponse;
    result['executionTime'] = executionTime;
    result['status'] = decodedResponse.status;
    let dbOrderHistory;
    if (orderType === null || orderType === void 0 ? void 0 : orderType.includes('WITHDRAW')) {
      const {
        token_address,
        token_amount,
        token_amount_formatted,
        usd_value,
        to_address,
        decimals,
        name,
        symbol,
        from_address,
        network
      } = transferParams;
      const wParams = {
        from_address,
        to_address,
        decimals,
        token_address,
        token_amount,
        token_amount_formatted,
        usd_value,
        type: 'withdraw',
        chain_id: isNaN(network) ? 0 : network,
        txn: executionHash,
        token_metadata: JSON.stringify(deepConvertBigInt({
          symbol,
          name
        })),
        result: JSON.stringify(deepConvertBigInt({
          decodedResponse,
          executionTime
        }))
      };
      dbOrderHistory = (await createDBTransferReceipt(wParams)).data;
    } else {
      dbOrderHistory = (await createDBOrderHistory(deepConvertBigInt({
        order_id: dbOrder.id,
        cloud_wallet_address: pkp === null || pkp === void 0 ? void 0 : pkp.additionalEthAddress,
        status: decodedResponse.error ? 'error' : 'success',
        result: result,
        token_prices: tokenPrices,
        token_out_prices: toAssetPriceData,
        execution_time: executionTime,
        pkp_eth_address: pkp === null || pkp === void 0 ? void 0 : pkp.ethAddress
      }))).data;
      console.log('Executing order EVM dbOrderHistory=>', dbOrderHistory);
    }
    if (decodedResponse.status == 'success' && !(orderType === null || orderType === void 0 ? void 0 : orderType.includes('WITHDRAW'))) {
      try {
        const executorUrl = (_j = getUrls()) === null || _j === void 0 ? void 0 : _j.EXECUTOR_URL;
        console.log('Executing order EVM executorUrl', executorUrl);
        const updateUrl = `/api/forwardGet?target=${executorUrl}/api/order/update-user-order?order_id=${dbOrder.id}&cloud_wallet=${pkp === null || pkp === void 0 ? void 0 : pkp.additionalEthAddress}`;
        console.log('Executing order EVM updateUrl=>', updateUrl);
        fetch(updateUrl);
      } catch (e) {
        console.log('Executing order EVM calling update url failed', e);
      }
    }
    console.log('Executing order EVM client side', result, executionTime);
    return {
      result,
      dbOrderHistory,
      dbOrder,
      time: executionTime,
      litNetwork: ENV_LIT_NETWORK
    };
  } catch (e) {
    console.error('[executeViaClientEVM] Error', e);
    throw e;
  }
}